import { render } from "./FeaturedCruiseCarousel.vue?vue&type=template&id=34b0c154&scoped=true"
import script from "./FeaturedCruiseCarousel.vue?vue&type=script&lang=js"
export * from "./FeaturedCruiseCarousel.vue?vue&type=script&lang=js"

import "./FeaturedCruiseCarousel.vue?vue&type=style&index=0&id=34b0c154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b0c154"]])

export default __exports__